import { ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { AuthProvider } from './context/AuthContext';
import { GlobalLoaderProvider } from './context/GlobalLoaderContext';
import useAppContext from './hooks/useAppContext';
import { createCustomTheme } from './muiTheme';
import queryClient from './queryClient';
import RouterGuard from './RouterGuard';

const App = () => {
  const { theme } = useAppContext();
  const customTheme = createCustomTheme(theme);

  return (
    <ThemeProvider theme={customTheme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <GlobalLoaderProvider>
            <RouterGuard />
          </GlobalLoaderProvider>
        </AuthProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
